<template>
    <v-menu v-model="menuOpen" :close-on-content-click="true" :close-on-click-outside="true">
        <template v-slot:activator="{ props }">
            <v-card v-bind="props" variant="plain"
                style="max-width: max-content; min-height: max-content; padding: auto;" elevated="3">
                <v-chip :variant="chipVariant" :color="chipColor" :density="isMessageTemplate ? 'compact' : 'default'" 
                    style="padding: auto; margin: auto;">
                    <div class="popup-container" ref="popupContainer" :style="{ maxWidth: chipWidth }">
                        <div v-if="isTagpopup">
                            <div v-for="tag in tags" :key="tag.tag_id" style="display: inline;" class="item">
                                <v-tooltip :location="'bottom'" :text="tag.tag_name">
                                    <template v-slot:activator="{ props }">
                                        <div v-bind="props" style="display: inline; padding: 0.2rem;">
                                            <v-icon size="20" :color="tag.tag_color" @click="selectTag(tag.tag_id)"
                                                elevation="5">
                                                mdi-{{ tag.tag_icon }}
                                            </v-icon>
                                        </div>
                                    </template>
                                </v-tooltip>
                            </div>
                        </div>
                        <div v-if="isQuickReminder">
                            <div v-for="reminder in reminders" :key="reminder.reminder_id" style="display: inline;"
                                class="item">
                                <v-tooltip :location="'bottom'" :text="reminder.reminder_title">
                                    <template v-slot:activator="{ props }">
                                        <div v-bind="props" style="display: inline; padding: 0.2rem;"
                                            @click="selectReminder(reminder)">
                                            <v-icon v-if="reminder.icon" size="25" :color="reminder.color">{{
                                                reminder.icon }}</v-icon>
                                            <v-avatar v-else color="primary" size="25">
                                                <span style="color: white; font-size: 0.6rem;">
                                                    {{ reminder.duration }}{{ getAbbr(reminder.unit) }}
                                                </span>
                                            </v-avatar>
                                        </div>
                                    </template>
                                </v-tooltip>
                            </div>
                        </div>
                        <div v-if="isContactType">
                            <div v-for="contact_type in contactTypes" :key="contact_type.type_id"
                                style="display: inline;" class="item">
                                <div v-if="contact_type.type_id !== contactData.contact_type && contact_type.can_be_set == true"
                                    style="display: inline;">
                                    <div @click="setContactType({ contact_id: contactData.contact_id, type_id: contact_type.type_id })"
                                        style="display: inline;">
                                        <v-tooltip bottom> <template v-slot:activator="{ props }">
                                                <v-avatar v-bind="props" rounded="lg" size="20"
                                                    :color="getContactColor(contact_type.type_id)"
                                                    style="margin-left: 4px;">
                                                    <span v-if="contactData.first_name == contactData.ph1">
                                                        <v-btn v-bind="props" icon variant="text" size="x-small">
                                                            <v-icon>mdi-account-outline</v-icon>
                                                        </v-btn>
                                                    </span>
                                                    <span v-else style="color: white; font-size: .7rem;">
                                                        {{ contactData.first_name.substring(0, 2).toUpperCase() }}
                                                    </span>
                                                </v-avatar>
                                            </template><span>{{ contact_type.type_name }}</span>
                                        </v-tooltip>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="isMessageTemplate" style="display: flex;">
                            <div  v-for="(item, ind) in messageTemplates" :key="ind">
                                <v-chip style="display: inline; margin-right: 2px;" variant="outlined" :color="item.color" @click="selectMessageTemplate(item.template)" label>{{ item.title }}</v-chip>
                            </div>
                        </div>
                    </div>
                    <div v-if="isAdmin && enableEdit" style="opacity: 0.5;"
                        @click="openSettings">
                        <v-icon size="23" color="secondary">
                            mdi-plus-circle</v-icon>
                        <v-tooltip activator="parent" location="bottom">
                            Add / Edit </v-tooltip>
                    </div>
                </v-chip>
            </v-card>
        </template>
    </v-menu>
</template>

<script>
import { mapGetters } from "vuex";
import EventBus from "@/eventBus";

export default {
    name: 'CustomPopup',
    props: {
        isTagpopup: { type: Boolean, default: false },
        tags: { type: Array, default: () => [] },
        isQuickReminder: { type: Boolean, default: false },
        reminders: { type: Array, default: () => [] },
        isContactType: { type: Boolean, default: false },
        contactTypes: { type: Array, default: () => [] },
        contactData: { type: Object, default: () => { } },
        enableEdit: { type: Boolean, default: false },
        isMessageTemplate: { type: Boolean, default: false },
        messageTemplates: { type: Array, default: () => [] },
        textareaWidth: { type: Number, default: 0 },
    },
    data() {
        return {
            menuOpen: false
        };
    },
    computed: {
        ...mapGetters(['isAdmin']),
        ...mapGetters("people", ["getContactColor"]),
        ...mapGetters("window",["windowWidth"]),
        chipVariant(){
            if (this.isContactType) {
                return 'elevated';
            } else if (this.isMessageTemplate) {
                return 'text';
            }else if(this.$route.path.includes('/conversation')){
                return 'elevated';
            }
            return 'outlined';
        },
        chipColor(){
             if (this.isContactType) {
                return "light_grey";
            } else if (this.isMessageTemplate) {
                return '';
            }else if(this.$route.path.includes('/conversation')){
                return "light_grey";
            }
            return 'success';
        },
        chipWidth(){ // it will follow the width of the textarea in the FDMessengerBox
            const reduce = 100; // reduce by 100px to fit in the area othewise it will overflow
            if(this.isMessageTemplate){
                return this.textareaWidth - reduce+ "px";
            }else{
                return "10rem"
            }
        }
    },
    methods: {
        selectTag(tag) {
            this.menuOpen = false;
            this.$emit('applyTag', tag);
        },

        openSettings() {
            this.menuOpen = false;
            if (this.isContactType) {
                EventBus.$emit("open-contact-type-settings");
                return;
            }
            if (this.isTagpopup) {
                 const path = this.$route.path;
      if (path.includes('/frontdesk')|| path.includes('/labCases')) {
        EventBus.$emit('open-tag-settings');
      } else if (path.includes('/conversation') || path.includes('/osclaims')) {
        EventBus.$emit('Open-Tag-Settings');
      }else{
                EventBus.$emit('open-tag-settings');
      }             
                return;
            }
            if(this.isMessageTemplate) {
                EventBus.$emit("open-message-template-settings");
                return;
            }
        },
        selectReminder(reminder) {
            this.menuOpen = false;
            this.$emit('applyReminder', reminder);
        },
        selectMessageTemplate(template) {
            this.$emit('applyMessageTemplate', template);
        },
        getAbbr(unit) {
            unit = unit.toLowerCase();
            switch (unit) {
                case 'minute':
                    return 'Min';
                case 'hour':
                    return 'Hr';
                case 'day':
                    return 'D';
                case 'week':
                    return 'Wk';
                case 'month':
                    return 'Mo';
                case 'year':
                    return 'Yr';
                default:
                    return '';
            }
        },
        setContactType(data) {
            this.menuOpen = false;
            this.$store.dispatch('people/setContactType', data);
        },
        // Scroll with mouse wheel
        onScroll(event) {
            const container = this.$refs.popupContainer;
            if (!container) return;

            // differentiate track pad and mouse
            let isTrackpad = false;
            if (event.wheelDeltaY) {
                if (Math.abs(event.wheelDeltaY) !== 120) {
                    isTrackpad = true;
                }
            }
            else if (event.deltaMode === 0) {
                isTrackpad = true;
            }

            // Horizontal scrolling behavior
            container.scrollLeft;
            container.scrollLeft += event.deltaY;

            // prevent parent scroll while using mouse wheel
            if (!isTrackpad) {
                event.preventDefault();
            }
        }
    },
    mounted() {
        const container = this.$refs.popupContainer;
        if (container) {
            container.addEventListener("wheel", this.onScroll, { passive: false });
        }
    },
    beforeUnmount() {
        const container = this.$refs.popupContainer;
        if (container) {
            container.removeEventListener("wheel", this.onScroll);
        }
    },

};
</script>
<style scoped>
.popup-container {
    display: flex;
    overflow-x: auto;
    white-space: nowrap;
    /* Adjust width as needed */
    scrollbar-width: none;
    /* Hide scrollbar in Firefox */
    -ms-overflow-style: none;
    /* Hide scrollbar in IE/Edge */
    scroll-behavior: smooth;
}

.popup-container::-webkit-scrollbar {
    display: none;
    /* Hide scrollbar in Chrome/Safari */
}

.item {
    display: inline-block;
}
</style>